import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import en from './langs/en.json';
import es from './langs/es.json';
import it from './langs/it.json';
import cn from './langs/cn.json';
import vn from './langs/vn.json';
import ms from './langs/ms.json';
import ar from './langs/ar.json';
import de from './langs/de.json';
import fr from './langs/fr.json';
import hi from './langs/hi.json';
import id from './langs/id.json';
import ja from './langs/ja.json';
import ml from './langs/ml.json';
import pl from './langs/pl.json';
import pt from './langs/pt.json';
import ru from './langs/ru.json';
import th from './langs/th.json';
import ur from './langs/ur.json';
import fa from './langs/fa.json';
import gr from './langs/gr.json';
import ko from './langs/ko.json';
import tr from './langs/tr.json';
import nl from './langs/nl.json';
import uk from './langs/uk.json';
import se from './langs/se.json';
import no from './langs/no.json';
import fi from './langs/fi.json';
import da from './langs/da.json';
import cz from './langs/cz.json';
import ro from './langs/ro.json';
import he from './langs/he.json';

const resources = {
    en: {
        translation: en
    },
    fi: {
        translation: fi
    },
    da: {
        translation: da
    },
    cz: {
        translation: cz
    },
    ro: {
        translation: ro
    },
    he: {
        translation: he
    },
    es: {
        translation: es
    },
    it: {
        translation: it
    },
    cn: {
        translation: cn
    },
    ms: {
        translation: ms
    },
    vn: {
        translation: vn
    },
    de: {
        translation: de
    },
    ar: {
        translation: ar
    },
    fr: {
        translation: fr
    },
    hi: {
        translation: hi
    },
    id: {
        translation: id
    },
    ja: {
        translation: ja
    },
    ml: {
        translation: ml
    },
    pl: {
        translation: pl
    },
    pt: {
        translation: pt
    },
    ru: {
        translation: ru
    },
    th: {
        translation: th
    },
    ur: {
        translation: ur
    },
    fa: {
        translation: fa
    },
    gr: {
        translation: gr
    },
    ko: {
        translation: ko
    },
    nl: {
        translation: nl
    },
    uk: {
        translation: uk
    },
    tr: {
        translation: tr
    },
    se: {
        translation: se
    },
    no: {
        translation: no
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        defaultNS: 'translation',
        lng: 'en',
        supportedLngs: ['en', 'fi', 'da', 'cz', 'ro', 'he', 'es', 'no', 'it', 'cn', 'ms', 'vn', 'ar', 'fr', 'hi', 'id', 'ja', 'ml', 'pl', 'pt', 'ru', 'se', 'th', 'ur', 'fa', 'de', 'gr', 'ko', 'nl', 'uk', 'tr'],
        fallbackLng: 'en',
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage']
        },
        interpolation: {
            escapeValue: false
        },
    });


export default i18n;
